<template>
  <div class="splash" :style="{ backgroundImage: 'url(' + splashImg + ')' }" @click="enter">
    <p class="hint">点击任意位置进入</p>
  </div>
</template>

<script>
import { api } from '@/utils/api';
import { getSite } from '@/utils/theme';
import { tryEnterLogistics } from '@/utils/cardSession';

export default {
  name: 'SplashPage',
  data() {
    return {
      splashImg: '',
      entering: false
    };
  },
  async created() {
    try {
      const data = await api.get('/api/site/assets?type=splash&site=' + getSite());
      if (data.code === 200 && data.data && data.data.length > 0) {
        this.splashImg = data.data[0].imagePath;
      }
    } catch { /* ignore */ }
  },
  methods: {
    async enter() {
      if (this.entering) return;
      this.entering = true;
      const entered = await tryEnterLogistics(this.$router);
      if (!entered) {
        this.$router.push('/verify');
      }
      this.entering = false;
    }
  }
};
</script>

<style scoped>
.splash {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.hint {
  position: fixed;
  bottom: 40px;
  color: #333;
  font-size: 14px;
  letter-spacing: 2px;
  animation: pulse 2s ease-in-out infinite;
}
@media (min-width: 768px) {
  .splash {
    background-size: contain;
  }
  .hint {
    bottom: 60px;
    font-size: 16px;
  }
}
@keyframes pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
</style>
